// extracted by mini-css-extract-plugin
export default {"formCont":"NewTopic_formCont__nzenT","plus-icon":"NewTopic_plus-icon__+Nb5e","input-container":"NewTopic_input-container__PJEAS","modal":"NewTopic_modal__Xq4RI"};